/** Um icone do sprite. `name` e o id sem o prefixo: Icon name="wa" -> #i-wa */
export function Icon({ name, className }: { name: string; className?: string }) {
  return (
    <svg className={className} aria-hidden="true">
      <use href={`#i-${name}`} />
    </svg>
  )
}
